let element;

export function init() {
	element = document.querySelector('.js-sticky-footer');

	if (!element) {
		return;
	}

	calcOffset();
	window.addEventListener('resize', calcOffset);
}


function calcOffset() {
	document.body.style.paddingBottom = `${element.clientHeight}px`;
}
